import React from "react";

const Image2 = () =>{
    return(
        <svg className="image2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0013 1.66602C5.41797 1.66602 1.66797 5.41602 1.66797 9.99935C1.66797 14.5827 5.41797 18.3327 10.0013 18.3327C14.5846 18.3327 18.3346 14.5827 18.3346 9.99935C18.3346 5.41602 14.5846 1.66602 10.0013 1.66602ZM8.33464 14.166L4.16797 9.99935L5.34297 8.82435L8.33464 11.8077L14.6596 5.48268L15.8346 6.66602L8.33464 14.166Z" fill="#94A3B8"/>
            </svg>
    )
}
export default Image2